import "../Pricing.scss";
import "../i18n";
import { TiersFormProps } from "./types";
import { useTranslation } from "react-i18next";
import TiersTable from "./tiersTable/TiersTable";

const TiersForm = ({ disableForm, testId }: TiersFormProps): JSX.Element => {
  const { t } = useTranslation("polygonPricing");

  return (
    <div className="pricing-form-container">
      <h2 className="subTitle-pending">
        <p className="subtitle-pricing-h3" data-testId={`${testId}-title`}>
          {t("tiersTitle")}
        </p>
      </h2>
      <div className="tiers-tables-container-fluid">
        <div className="tiers-tables-container-row">
          <div className="tiers-tables-container-col">
            <TiersTable
              name="day"
              disabled={disableForm}
              testId={`${testId}-day`}
            />
          </div>
          <div className="tiers-tables-container-col">
            <TiersTable
              name="week"
              disabled={disableForm}
              testId={`${testId}-week`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default TiersForm;
